__turbopack_context__.v({
  "image": "CategoryTile-module-scss-module__7njYuW__image",
  "imageArea": "CategoryTile-module-scss-module__7njYuW__imageArea",
  "imageContainer": "CategoryTile-module-scss-module__7njYuW__imageContainer",
  "label": "CategoryTile-module-scss-module__7njYuW__label",
  "tile": "CategoryTile-module-scss-module__7njYuW__tile",
});
